module.exports = __webpack_public_path__ + "img/Stratasys-fortus-400mc.c06024d3.png";